<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <span class="loading-spiner" *ngIf="!country"></span>

    <form class="form-horizontal" autocomplete="off" novalidate *ngIf="country">
      <app-translation-content-title [language]="language"></app-translation-content-title>

      <!-- Name -->
      <div class="form-group">
        <label class="col-md-3 control-label">{{ 'NAME' | translate }}</label>
        <div class="col-md-9">
          <div class="form-label">{{ country.name }}</div>
        </div>
      </div>
    </form>
  </div>
</div>
